import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const EMBER = "#FF6B35";

export default function RouteProgress() {
  const { pathname } = useLocation();
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(true);
    const t = setTimeout(() => setActive(false), 500);
    return () => clearTimeout(t);
  }, [pathname]);

  if (!active) return null;

  return (
    <div
      className="route-progress-bar"
      style={{ backgroundColor: EMBER }}
    />
  );
}
